import { render, staticRenderFns } from "./WrongAnswerEvaluation.vue?vue&type=template&id=92a2869c&scoped=true"
import script from "./WrongAnswerEvaluation.vue?vue&type=script&lang=js"
export * from "./WrongAnswerEvaluation.vue?vue&type=script&lang=js"
import style0 from "./WrongAnswerEvaluation.vue?vue&type=style&index=0&id=92a2869c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a2869c",
  null
  
)

export default component.exports